import { render, staticRenderFns } from "./GraphsAdvisor.vue?vue&type=template&id=61856872&scoped=true"
import script from "./GraphsAdvisor.vue?vue&type=script&lang=js"
export * from "./GraphsAdvisor.vue?vue&type=script&lang=js"
import style0 from "./GraphsAdvisor.vue?vue&type=style&index=0&id=61856872&prod&scoped=true&lang=css"
import style1 from "./GraphsAdvisor.vue?vue&type=style&index=1&id=61856872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61856872",
  null
  
)

export default component.exports